import PassengerBoxMessages from './Passenger.Messages';
import Helper from '../helper';

const passengerBoxValidation = {
    validateContactInfoBoxValue(pContact){

        return new Promise(resolve=>{
            


        let validate = {
            showAlert:false,
            message:"",
            errorCode:0
        };
        
        if(pContact.phoneNo==null||pContact.phoneNo==""){
            validate.showAlert = true;
            validate.errorCode = 9;
            validate.message = this.getValidationMessage(validate.errorCode);
            //return validate;
            resolve(validate)
        }

        let name = pContact.firstName + pContact.middleName + pContact.lastName;
        //alert(name);
        if(name==null||name==""){
            validate.showAlert = true;
            validate.errorCode = 10;
            validate.message = this.getValidationMessage(validate.errorCode);
            //return validate;
            resolve(validate)
        }

        if(pContact.email==null||pContact.email==""||!Helper.textFormatValidation.isEmail(pContact.email)){
            validate.showAlert = true;
            validate.errorCode = 11;
            validate.message = this.getValidationMessage(validate.errorCode);
            //return validate;
            resolve(validate)
        }
        resolve(validate)
        //return validate;
        });        
    },
    validatePassengerBoxValue(pPassenger,fnc){
        let validate = {
            showAlert:false,
            message:"",
            errorCode:0
        };

        if(pPassenger.firstName==null||pPassenger.firstName==""){
            validate.showAlert = true;
            validate.errorCode = 1;
            validate.message = this.getValidationMessage(validate.errorCode);
            return validate;
        }

        if(pPassenger.lastName==null||pPassenger.lastName==""){
            validate.showAlert = true;
            validate.errorCode = 2;
            validate.message = this.getValidationMessage(validate.errorCode);
            return validate;
        }  
        
        if(pPassenger.title==null||pPassenger.title==""){
            validate.showAlert = true;
            validate.errorCode = 3;
            validate.message = this.getValidationMessage(validate.errorCode);
            return validate;
        }          

        let birthdayDate = pPassenger.dobYear + "-" + pPassenger.dobMonth + "-" + pPassenger.dobDay;

        if (this.checkBirthdayDateAdt(birthdayDate)==false && pPassenger.passengerTypeCode=="ADT"&&birthdayDate!="null-null-null"){
            validate.showAlert = true;
            validate.errorCode = 4;
            validate.message = this.getValidationMessage(validate.errorCode);
            return validate;
        }

        if (this.checkBirthdayDateCnn(birthdayDate)==false && (pPassenger.passengerTypeCode=="CNN"||pPassenger.passengerTypeCode=="CHD")){
            validate.showAlert = true;
            validate.errorCode = 5;
            validate.message = this.getValidationMessage(validate.errorCode);
            return validate;
        }
        
        if (this.checkBirthdayDateInf(birthdayDate)==false && pPassenger.passengerTypeCode=="INF"){
            validate.showAlert = true;
            validate.errorCode = 6;
            validate.message = this.getValidationMessage(validate.errorCode);
            return validate;
        }        

        
        if (pPassenger.isContactPerson){
            if (pPassenger.phoneNo == null || pPassenger.phoneNo==""){
                validate.showAlert = true;
                validate.errorCode = 7;
                validate.message = this.getValidationMessage(validate.errorCode);
                
                return validate;                
            }

            if (pPassenger.email == null || pPassenger.email==""||!Helper.textFormatValidation.isEmail(pPassenger.email)){
                validate.showAlert = true;
                validate.errorCode = 8;
                validate.message = this.getValidationMessage(validate.errorCode);
                return validate;                
            }            
        }

        if (fnc!=null){fnc();}
        
        return validate;
    },
    checkBirthdayDateAdt(bdDate){
        if (Helper.dateAndTime.isValidISODate(bdDate)){
            let date1 = Helper.dateAndTime.convertISODateStringToDate(bdDate);
            let age = Helper.dateAndTime.calculateAge(date1);
            return +age > 11;
        }else {
            return false;
        }
        
    },
    checkBirthdayDateCnn(bdDate){
        if (Helper.dateAndTime.isValidISODate(bdDate)){
            let date1 = Helper.dateAndTime.convertISODateStringToDate(bdDate);
            let age = Helper.dateAndTime.calculateAge(date1);
            return +age>2 && +age <12;
        }else {
            return false;
        }
    },
    checkBirthdayDateInf(bdDate){
        if (Helper.dateAndTime.isValidISODate(bdDate)){
            let date1 = Helper.dateAndTime.convertISODateStringToDate(bdDate);
            let age = Helper.dateAndTime.calculateAge(date1);
            return +age < 2;
        }else {
            return false;
        }
    },
    getValidationMessage(errorCode){
        let keys = [
            "firstNameRequired",
            "lastNameRequired",
            "titleNotSpecified",
            "invalidBirthday",
            "invalidBirthdayCnn",
            "invalidBirthdayInf",
            "phoneNoRequired",
            "emailRequired",
            "contactPhoneNoRequired",
            "contactNameRequired",
            "contactEmailRequired",
        ];
        return PassengerBoxMessages.validationErrorMessages[keys[errorCode-1]];
    }
};

export default passengerBoxValidation;